import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationLargestArmyView} from './UIGamePlayerInformationLargestArmyView'
import {UIGameMechanic} from '../UIGameEventController'
import {PlayerValidator, MechanicValidatorLargestArmy} from '@colonist/game-mechanic-validators'
import {InGameAchievement} from '../ui_game_achievement/UIGameAchievementController'
import {Sound} from '../../Sound'
import {TranslationObject} from '@colonist/i18n'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'
import {CardEnum, MechanicLargestArmyState, PlayerColor} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export abstract class UIGamePlayerInformationLargestArmyController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private readonly largestArmyValidator: MechanicValidatorLargestArmy

    protected playerInformationLargestArmyViews: UIGamePlayerInformationLargestArmyView[]
    private lastPlayerToHoldLargestArmy: PlayerColor

    constructor(uiGameManager: UIGameManager, largestArmyState: MechanicLargestArmyState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.largestArmyValidator = new MechanicValidatorLargestArmy(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, largestArmyState)

        this.playerInformationLargestArmyViews = []
        this.lastPlayerToHoldLargestArmy = this.largestArmyValidator.getPlayerWithLargestArmy()

        this.initPlayerInformationLargestArmyViews()
    }

    protected abstract initPlayerInformationLargestArmyViews()

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateLargestArmyStatus(data); break
            case UIGameEventEnums.CanvasResized: this.initPlayerInformationLargestArmyViews(); break
            default: break
        }
    }

    private getPlayerInformationLargestArmyView(player: PlayerColor): UIGamePlayerInformationLargestArmyView | undefined {
        for(const playerInformationLargestArmyView of this.playerInformationLargestArmyViews) {
            if(playerInformationLargestArmyView.playerState.color == player) return playerInformationLargestArmyView
        }
        return undefined
    }

    private updateLargestArmyStatus(animate: boolean) {
        for(const player of this.uiGameManager.gameState.players) {
            if(!this.largestArmyValidator.getLargestArmyPlayerState(player.color).hasLargestArmy) continue
            if(player.color == this.lastPlayerToHoldLargestArmy) continue

            this.playerAchievedLargestArmy(player, animate)
        }
    }

    private playerAchievedLargestArmy(playerState: PlayerValidator, animate: boolean) {
        const playerInformationLargestArmyView = this.getPlayerInformationLargestArmyView(playerState.color)
        if(playerInformationLargestArmyView == undefined) return

        const title: TranslationObject = {key: 'strings:game.playerInformation.largestArmy.title'}
        const playerInformationView = this.uiGameManager.playersController.getPlayerInformationViewWithColor(playerState.color)
        const developmentCardsUsed = playerInformationView?.developmentCardsPlayerState?.developmentCardsUsed ?? []
        const knightDevelopmentCardsUsedCount = ArrayUtils.countOccurenceOfValueInArray(developmentCardsUsed, CardEnum.Knight)
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_largest_army_highlight)

        const achievement: InGameAchievement = {
            title: title,
            achievementOwnerNew: playerState.color,
            achievementOwnerPrevious: this.lastPlayerToHoldLargestArmy,
            achievementScore: knightDevelopmentCardsUsedCount,
            victoryPointChange: 2,
            achievementDurationInSeconds: 1.5,
            soundType: Sound.SoundType.AchievementLargestArmy,
            bottomDescription: {key: 'strings:game.achievements.bottomDescription.2VPs'},
            iconTexture: texture,
        }

        this.lastPlayerToHoldLargestArmy = playerState.color

        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }
}
